// extracted by mini-css-extract-plugin
export var menuIcon = "_jp-0";
export var menuIconInline = "_jp-1";